<template>
  <div class="line">
    <div :class="['line--line', { last: landingIndex === 5 }]"></div>
  </div>
</template>

<script>
export default {
  name: "yellowLine",
  props: {
    landingIndex: {
      type: Number,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  &--line {
    height: toRem(1);
    width: 100%;
    background-color: $primary-yellow;
    &.last {
      width: calc(100% - 18.2vw);
    }
  }
}
</style>
